import { render, staticRenderFns } from "./financialDetails.vue?vue&type=template&id=487aa35d&scoped=true"
import script from "./financialDetails.vue?vue&type=script&lang=js"
export * from "./financialDetails.vue?vue&type=script&lang=js"
import style0 from "./financialDetails.vue?vue&type=style&index=0&id=487aa35d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487aa35d",
  null
  
)

export default component.exports